// extracted by mini-css-extract-plugin
module.exports = {"title":"FJStockListTitle_title__2HkDk","keyword_title":"FJStockListTitle_keyword_title__20DYL","title_normal":"FJStockListTitle_title_normal__36Dul"};